/**
 * WordPress dependencies.
 */
import { __ } from "@wordpress/i18n";

const Footer = () => {
    // auto change the year
    const year = new Date().getFullYear();
    const yearText = year === 2024 ? year : `2024 - ${year}`;

  return (
    <footer className="slideverse-footer">
      <div className="slideverse-container">

        {__(
          `Copyright ©${yearText} SlideVerse. All Rights Reserved.`,
          "slideverse"
        )}
      </div>
    </footer>
  );
};

export default Footer;
